import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconM3 from '../build/icon-m3'

export const IconM3: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconM3} />
}

export default IconM3
